// --- START OF FILE Indicacao.js ---

import React, { useState, useContext } from "react";
import * as S from "./IndicacaoStyle";
import Loading from "../Loader";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import { FaTimes, FaSearch } from "react-icons/fa";

const base_route = process.env.REACT_APP_API_BASE_URL;
const ADD_INDICACAO = process.env.REACT_APP_ADICIONAR_INDICACAO_GOLDEN;

export default function Indicacao() {
  const { getClients, authState, clientsDataBase } = useContext(AuthContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [indicationAddValue, setIndicationAddValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSelectClient = (client) => {
    setSelectedClient(client);
    setSearchTerm("");
  };

  const handleUnSelectClient = () => {
    setSelectedClient(null);
  };

  const fetchClients = async () => {
    setLoading(true);
    try {
      await getClients(50, 0, searchTerm, "asc", ""); // A ordem 'crescente' foi trocada para 'asc' para padronizar
    } catch (e) {
      console.log(e);
    } finally {
        setLoading(false);
    }
  };

  const handleSendIndicacao = async () => {
    if (!indicationAddValue || isNaN(indicationAddValue) || parseFloat(indicationAddValue) <= 0) {
      alert("Por favor, insira um valor numérico válido e maior que zero.");
      return;
    }
    setLoading(true);
    const headers = { headers: { Authorization: `Bearer ${authState.accessToken || ""}` } };
    try {
      const response = await axios.post(
        `${base_route}${ADD_INDICACAO}`,
        {
          clientId: selectedClient.id,
          amount: parseFloat(indicationAddValue),
          description: "Adicionado pela Golden",
        },
        headers
      );
      if (response.status === 201) {
        alert("SALDO ADICIONADO COM SUCESSO");
        setIndicationAddValue("");
        setSelectedClient(null);
      } else {
        alert(`Erro: ${response.data.message || 'Ocorreu um erro.'}`);
      }
    } catch (error) {
      alert(`Erro ao adicionar indicação: ${error.message}`);
      console.log(error);
    } finally {
        setLoading(false);
    }
  };

  return (
    <S.IndicacaoContainer>
      <Loading load={loading} />
      <S.ContentBox>
        <S.Header>
          <h1>Adicionar Saldo de Indicação</h1>
        </S.Header>

        <S.ClientSearch>
          <h4>1. Pesquise e selecione o cliente</h4>
          <div className="inputBoxFilter">
            <input
              type="text"
              placeholder="Digite o nome ou CPF do cliente"
              value={searchTerm}
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === 'Enter' && fetchClients()}
            />
            <button onClick={fetchClients}><FaSearch/></button>
          </div>

          <S.SearchArea>
            <S.SearchedClients>
                <div className="columns">
                    <span>NOME</span>
                    <span>CPF</span>
                    <span>EMAIL</span>
                </div>

                {selectedClient ? (
                  <div className="rowSelected">
                    <span>{selectedClient.name}</span>
                    <span>{selectedClient.cpfCnpj}</span>
                    <span>{selectedClient.email}</span>
                    <button onClick={handleUnSelectClient} style={{background: 'transparent', border: 'none', color: '#111', cursor: 'pointer'}}><FaTimes /></button>
                  </div>
                ) : (
                  <div className="tabelona">
                    {clientsDataBase && clientsDataBase.map((client, index) => (
                        <div key={index} onClick={() => handleSelectClient(client)} className="row">
                            <span>{client.name}</span>
                            <span>{client.cpfCnpj}</span>
                            <span>{client.email}</span>
                        </div>
                    ))}
                  </div>
                )}
            </S.SearchedClients>
          </S.SearchArea>
        </S.ClientSearch>

        {selectedClient && (
          <S.QuandoDeseja>
            <span>2. Quanto deseja adicionar ao saldo de <strong>{selectedClient.name}</strong>? (R$)</span>
            <input
              type="number"
              value={indicationAddValue}
              onChange={(e) => setIndicationAddValue(e.target.value)}
              placeholder="0,00"
            />
            <button onClick={handleSendIndicacao}>ADICIONAR SALDO</button>
          </S.QuandoDeseja>
        )}
      </S.ContentBox>
    </S.IndicacaoContainer>
  );
}